import React from 'react';
import type { FC } from 'react';

interface Props {
  readonly show: boolean;
}

const SidebarDivider : FC<Props> = ({ show }) => {
  if (show) {
    return <br />;
  } else {
    return null;
  }
};

export default SidebarDivider;
